export const findNextFocusIndex = (wordDistribution, currentFocusedIndex, letterState) => {
    const lettersOrdered = [wordDistribution.slice(currentFocusedIndex + 1), wordDistribution.slice(0, currentFocusedIndex + 1)].flat();
    const letterSelected = lettersOrdered.find(letter => !letterState[letter.id].correct);
    const nextIndex = wordDistribution.findIndex(letter => letter.id === letterSelected.id);
    return nextIndex;
}

export const findPreviousFocusIndex = (wordDistribution, currentIndex, newLetters) => {
    const orderedWords = [wordDistribution.slice(currentIndex + 1), wordDistribution.slice(0, currentIndex)].flat().reverse();
    const firstLetter = orderedWords.find(letter => !newLetters[letter.id].correct);
    const prevIndex = wordDistribution.findIndex(letter => letter.id === firstLetter.id);
    return prevIndex;
}

export const getNextID = (row, column, direction) => {
    switch (direction) {
        case 'right':
            return `${row}-${column + 1}`;
        case 'left':
            return `${row}-${column - 1}`;
        case 'up':
            return `${row - 1}-${column}`;
        case 'down':
            return `${row + 1}-${column}`;
        default:
            return `${row}-${column}`;
    }
};
